
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/it-stajyeri-kariyer-basvuru",
      function () {
        return require("private-next-pages/it-stajyeri-kariyer-basvuru.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/it-stajyeri-kariyer-basvuru"])
      });
    }
  